import { toast } from './toast';
import { STORAGE_KEYS } from '@/constants';

export const handleTokenExpiration = (error) => {
  if (error?.name === 'TokenExpiredError' || 
      error?.message?.includes('jwt expired') ||
      error?.message?.includes('token expired') ||
      error?.message?.includes('TokenExpiredError')) {
    
    // Clear localStorage
    Object.values(STORAGE_KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
    
    // Clear cookies
    document.cookie.split(";").forEach(function(c) { 
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
    });
    
    // Show toast notification
    toast.error('Session expired. Please login again.');
    
    // Redirect to login page immediately
    window.location.href = '/auth/sign-in';
    
    return true;
  }
  return false;
};

export const makeAuthenticatedRequest = async (url, options = {}) => {
  try {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    
    if (!token) {
      window.location.href = '/auth/sign-in';
      return null;
    }
    
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
        Authorization: `Bearer ${token}`,
      },
    });

    // Check if response indicates token expiration
    if (response.status === 401) {
      const data = await response.clone().json().catch(() => ({}));
      
      if (data.error?.includes('jwt expired') || 
          data.error?.includes('token expired') ||
          data.error?.includes('TokenExpiredError') ||
          data.message?.includes('jwt expired')) {
        handleTokenExpiration({ message: 'jwt expired' });
        return null;
      }
    }
    
    // Also check for 500 errors that might contain JWT expiration info
    if (response.status === 500) {
      const data = await response.clone().json().catch(() => ({}));
      
      if (data.error?.includes('jwt expired') || 
          data.error?.includes('TokenExpiredError')) {
        handleTokenExpiration({ message: 'jwt expired' });
        return null;
      }
    }

    return response;
  } catch (error) {
    if (handleTokenExpiration(error)) {
      return null;
    }
    throw error;
  }
};
